import { IconWrapper } from '../runtime';
export default IconWrapper('two-people', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10.6 13.7498H13.8C14.4627 13.7498 15 13.2125 15 12.5498V11.7498C15 9.76159 13.3882 8.14993 11.4 8.14979C10.8 8.14974 10.1325 8.35047 9.59998 8.54979M7.20002 3.39979C7.20002 4.72527 6.12551 5.79979 4.80002 5.79979C3.47454 5.79979 2.40002 4.72527 2.40002 3.39979C2.40002 2.0743 3.47454 0.999786 4.80002 0.999786C6.12551 0.999786 7.20002 2.0743 7.20002 3.39979ZM13.2 3.79979C13.2 4.7939 12.3941 5.59979 11.4 5.59979C10.4059 5.59979 9.59998 4.7939 9.59998 3.79979C9.59998 2.80567 10.4059 1.99979 11.4 1.99979C12.3941 1.99979 13.2 2.80567 13.2 3.79979ZM2.2 14.7498H7.4C8.06274 14.7498 8.6 14.2125 8.6 13.5498V11.7498C8.6 9.65109 6.89868 7.99976 4.8 7.99976C2.70132 7.99976 1 9.65109 1 11.7498V13.5498C1 14.2125 1.53726 14.7498 2.2 14.7498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});